import { Record } from "immutable";

/* eslint-disable import/prefer-default-export */
export const StateValue = Record({
  device: 100000,
  devicePrice: 15600.0,
  activationPrice: 62400.0,
  updateSize: 100,
  storagePrice: 0.01,
  rollout: 0,
  rolloutPrice: 20794.8,
  percentualDevice: 10,
  transferPrice: 95.0
});
